export default {
  readMore: 'Czytaj więcej',
  fullText: 'Pełny tekst',
};
